const API_URL = (exports.API_URL = process.env.REACT_APP_API_URL);
const APP_URL = (exports.APP_URL = process.env.REACT_APP_APP_URL);
const PLATFORM = (exports.PLATFORM = process.env.REACT_APP_PLATFORM);
const recaptcha_token = (exports.recaptcha_token = process.env.REACT_APP_RECAPTCHA_TOKEN);
const STRIPE_KEY = (exports.STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY);
